import React from 'react';
import { motion } from 'framer-motion';
import ApprenantsManager from '../../components/Admin/ApprenantsManager';

const ApprenantsPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"
    >
      <div className="h-32"></div>
      <div className="max-w-7xl mx-auto px-6 py-8">
        <ApprenantsManager />
      </div>
    </motion.div>
  );
};

export default ApprenantsPage;